import type { EnumParameter, StringParameter } from '@witmetrics/utils';
import { PARAMETER_TYPES } from '@witmetrics/utils/constants';

export const ENGRAVED_TYPE = {
  ORDER_NAME: 'ORDER_NAME',
  CUSTOM_TEXT: 'CUSTOM_TEXT',
  NO_ENGRAVING: 'NO_ENGRAVING',
} as const;

export const ENGRAVED_PARAMETER: EnumParameter = {
  type: PARAMETER_TYPES.ENUM,
  key: 'engraved_options',
  name: 'engravedOptions',
  label: 'Engraved Text',
  defaultValue: 'orderName',
  description: 'Text to be engraved on the model',
  imgSrc: 'text_engrave.svg',
  options: [
    { label: 'Order Name', value: ENGRAVED_TYPE.ORDER_NAME },
    { label: 'Custom Text', value: ENGRAVED_TYPE.CUSTOM_TEXT },
    { label: 'No Engraving', value: ENGRAVED_TYPE.NO_ENGRAVING },
  ],
};

export const TEXT_PARAMETER: StringParameter = {
  type: PARAMETER_TYPES.STRING,
  key: 'engraved_text',
  name: 'engravedText',
  label: 'Custom Text',
  defaultValue: '',
  description: 'Text to be engraved on the model',
};
